// store.js
import Vue from 'vue'
import Vuex, {Payload, Store} from 'vuex'
import localforage from 'localforage'
import VuexPersistence from 'vuex-persist'
import moduleFarm from './modules/farm'
import moduleAnimal from './modules/animal'
import moduleProfile from './modules/profile'
import initialState from './initialState'

Vue.use(Vuex);

const vuexForage = new VuexPersistence({
    key: 'molokoden',
    storage: localforage,
    asyncStorage: true
})

const store = new Vuex.Store({
    strict: true,
    modules: {
        farm: moduleFarm,
        animal: moduleAnimal,
        profile: moduleProfile,
    },
    mutations: {
        reset: state => {
            Object.keys(state).forEach(module => {
                Object.keys(state[module]).forEach(key => {
                    state[module][key] = initialState[module][key]
                })
            })
        }
    },
    plugins: [vuexForage.plugin]
});

// if (module.hot) {
//     // accept actions and mutations as hot modules
//     module.hot.accept(['./modules/farm', './modules/animal', './modules/profile'], () => {
//         // require the updated modules
//         // have to add .default here due to babel 6 module output
//         const newModuleFarm = require('./modules/farm').default
//         const newModuleAnimal = require('./modules/animal').default
//         const newModuleProfile = require('./modules/profile').default
//         // swap in the new modules and mutations
//         store.hotUpdate({
//             modules: {
//                 farm: newModuleFarm,
//                 animal: newModuleAnimal,
//                 profile: newModuleProfile
//             }
//         })
//     })
// }

export default store